import React from 'react';

class Config extends React.Component {
  render() {
    return (
      <h1 data-testid="settings-title">Configurações</h1>
    );
  }
}
export default Config;
